import React, { useState } from "react";
import styled from "styled-components";
import Button from "./Button";
import Logo from "./Logo";
import Facebook from "../Icons/Facebook";
import Instagram from "../Icons/Instagram";
import Twitter from "../Icons/Twitter";
import LinkedIn from "../Icons/LinkedIn";
import { FaFacebook, FaInstagram, FaYoutube, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { fb_url, ins_url } from "../fresha_url";

const Section = styled.section`
  width: 100vw;
  background-color: ${(props) => props.theme.darkblue};
`;
const NavBar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 85%;
  height: ${(props) => props.theme.navHeight};
  margin: 0 auto;
color: ${(props) => props.theme.body};

  .mobile {
    display: none;
  }

  @media (max-width: 64em) {
    .desktop {
      display: none;
    }
    .mobile {
      display: inline-block;
    }
  }
`;
const Menu = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style: none;

  @media (max-width: 64em) {
    /* 1024 px */

    position: fixed;
    top: ${(props) => props.theme.navHeight};
    left: 2.5%;
    right: 0;
    bottom: 0px;
    width: 95vw;
    height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
    z-index: 50;
    background-color: ${(props) => `rgba(${props.theme.darkRgba},0.8)`};
    backdrop-filter: blur(2px);
    border-radius: 50px;

    transform: ${(props) =>
      props.click ? "translateY(0)" : `translateY(-1000%)`};
    transition: all 0.5s ease;
    flex-direction: column;
    justify-content: center;

    touch-action: none;
  }
`;

const MenuItem = styled.li`
  margin: 0 1rem;
  color: ${(props) => props.theme.body};
  cursor: pointer;
  font-size: ${(props) => props.theme.fontlg};
  font-family: "montserrat", handwriting;
  &::after {
    content: " ";
    display: block;
    width: 0%;
    height: 2px;
    background: ${(props) => props.theme.text};
    transition: width 0.3s ease;
  }
  &:hover::after {
    width: 100%;
  }

  @media (max-width: 64em) {
    margin: 1rem 0;
    font-size: ${(props) => props.theme.fontmd};

    &::after {
      display: none;
    }
  }
`;
const HamburgerMenu = styled.span`
  width: ${(props) => (props.click ? "2rem" : "1.5rem")};

  height: 2px;
  background: ${(props) => props.theme.body};

  position: absolute;
  // position: sticky;
  top: 2.5rem;
  right: 3%;
  transform: ${(props) =>
    props.click
      ? "translateX(-50%) rotate(90deg)"
      : "translateX(-50%) rotate(0)"};

  display: none;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  transition: all 0.3s ease;

  @media (max-width: 64em) {
    /* 1024 px */
    display: flex;
  }

  &::after,
  &::before {
    content: " ";
    width: ${(props) => (props.click ? "1rem" : "1.5rem")};
    height: 2px;
    right: ${(props) => (props.click ? "-2px" : "0")};
    background: ${(props) => props.theme.body};
    position: absolute;
    transition: all 0.3s ease;
  }

  &::after {
    top: ${(props) => (props.click ? "0.3rem" : "0.5rem")};
    transform: ${(props) => (props.click ? "rotate(-40deg)" : "rotate(0)")};
  }
  &::before {
    bottom: ${(props) => (props.click ? "0.3rem" : "0.5rem")};
    transform: ${(props) => (props.click ? "rotate(40deg)" : "rotate(0)")};
  }
`;

const IconList = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem auto;

  & > * {
    padding: 1rem;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.2);
    }
  }
`;

const Navigation = () => {
  const [click, setClick] = useState(false);

  const facebook = fb_url
  const instagram=ins_url

  const scrollTo = (id) => {
    let element = document.getElementById(id);

    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    setClick(!click);
  };



  return (
    <Section id="navigation">
      <NavBar>
        <Logo />
        <HamburgerMenu click={click} onClick={() => setClick(!click)}>
          &nbsp;
        </HamburgerMenu>
        <Menu click={click}>
          <MenuItem onClick={() => scrollTo("home")}>Home</MenuItem>
          <MenuItem onClick={() => scrollTo("about")}>About Us</MenuItem>
          <MenuItem onClick={() => scrollTo("nails")}>
            Nails services
          </MenuItem>
          <MenuItem onClick={() => scrollTo("beauty")}>
            Beauty services
          </MenuItem>
          {/* <MenuItem onClick={() => scrollTo("photos")}>Photos</MenuItem> */}
          {/* <MenuItem onClick={() => scrollTo("team")}>Facebook</MenuItem> */}
          <MenuItem onClick={() => scrollTo("instagram")}>Instagram</MenuItem>
          <MenuItem onClick={() => scrollTo("contactus")}>Contact Us</MenuItem>
          <MenuItem>
            <div className="mobile">
              <IconList>
                <a
                  href={facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="facebook"
                >
                  <FaFacebook size={30} />
                </a>
                <a
                  href={instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="instagram"
                >
                  <FaInstagram size={30}/>
                </a>
              </IconList>
            </div>
          </MenuItem>
        </Menu>

        <div className="desktop">
          {/* <Button text="Connect Wallet" link="https://google.com" /> */}
          <IconList>
            <a
              href={facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="facebook"
            >
               <FaFacebook size={30} />
            </a>
            <a
              href={instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="instagram"
            >
              <FaInstagram size={30}/>
            </a>
          </IconList>
        </div>
      </NavBar>
    </Section>
  );
};

export default Navigation;
